module.exports = "<p>employees-payroll-amount works!</p>\r\n"